interface GuideTheme {
    id: string;
    coreColor: string;
    brandImageUrl: string;
    homepageTopImageUrl?: string;
    headerImageUrl: string;
    styling: {
        circle: {
            bgColor: string;
            iconColor: string;
        };
        matchColor: string;
        tileColor: string;
        pageHeaderShadow?: string;
    };
}

export const DEFAULT_THEME: GuideTheme = {
    id: 'default',
    coreColor: '#BDD2E5',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/002d300e-eb06-4c41-9cea-7ab6c0795f8b.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/3d2e5da9-9609-4e1c-88b7-0fc70c732418.jpeg',
    styling: {
        tileColor: '#E2EBF1',
        matchColor: '#041321',
        circle: {
            bgColor: '#C57142',
            iconColor: '#ffffff'
        }
    }
};

export const DARK_THEME: GuideTheme = {
    id: 'dark',
    coreColor: '#343434',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/d7dd75ac-c20f-4332-afa1-50167bafc584.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/4d1b7e55-c9eb-4ab1-978b-eea010a09f57.jpeg',
    styling: {
        tileColor: '#F4F4F4',
        matchColor: '#FFFFFF',
        circle: {
            bgColor: '#343434',
            iconColor: '#FFFFFF'
        }
    }
};

export const LIGHT_THEME: GuideTheme = {
    id: 'light',
    coreColor: '#EFF3F9',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/646d79b2-5e41-43ae-9b1f-d1db20a0670a.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/7f9624ac-a5d2-4a87-8f1e-b3f30353cb1c.jpeg',
    styling: {
        tileColor: '#FAFCFE',
        matchColor: '#353A3D',
        circle: {
            bgColor: '#353A3D',
            iconColor: '#FFFFFF'
        }
    }
};

export const BM_THEME: GuideTheme = {
    id: 'bm',
    coreColor: '#0F1D44',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/af6f2e3c-c12f-4dcb-a145-bebbb0d8057e.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/bdefe01d-7089-4056-a17d-7a5e585ccd2e.jpeg',
    styling: {
        tileColor: '#EAF0F5',
        matchColor: '#FFFFFF',
        circle: {
            bgColor: '#F9F871',
            iconColor: '#3A3A3A'
        }
    }
};

export const UTRECHT_THEME: GuideTheme = {
    id: 'utrecht',
    coreColor: '#FFCE00',
    headerImageUrl: 'https://dvtqxks0zalev.cloudfront.net/ad9d370b-ca9f-47d7-a971-5d36236c08c7.png',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/7c433bc9-c5df-4f2c-bc01-71b3efb3d099.png',
    styling: {
        tileColor: '#FCEFBB',
        matchColor: '#000',
        circle: {
            bgColor: '#000',
            iconColor: '#fff'
        }
    }
};

export const FREDRIKSTAD_THEME: GuideTheme = {
    id: 'fredrikstad',
    coreColor: '#CE190E',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/cfa46233-af13-4d37-b468-16cadedecdb2.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/9f9b98a3-2373-4ccc-b190-f686f9020179.jpeg',
    styling: {
        tileColor: '#FFECEC',
        matchColor: '#ffffff',
        circle: {
            bgColor: '#2F393F',
            iconColor: '#ffffff'
        }
    }
};

export const KARIERA2024_THEME: GuideTheme = {
    id: 'kariera2024',
    coreColor: '#5BA090',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/3f5b668e-fb7e-4d96-b406-763c67c259dd.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/a8fa947d-f316-4d0c-b659-26349603b0c0.jpeg',
    styling: {
        tileColor: '#ECFFFC',
        matchColor: '#ffffff',
        circle: {
            bgColor: '#212837',
            iconColor: '#fff'
        }
    }
};

export const MARENA_THEME: GuideTheme = {
    id: 'marena',
    coreColor: '#B3DDFD',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/ae316db7-4bb4-4a80-a09c-22066d12ff68.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/e1353f70-552f-422d-8935-556b9f9d8a3e.jpeg',
    styling: {
        circle: {
            bgColor: '#334A52',
            iconColor: '#fff'
        },
        matchColor: '#041321',
        tileColor: '#EAF0F5'
    }
};

export const NAMSSKOGAN_THEME: GuideTheme = {
    id: 'namsskogan',
    coreColor: '#734527',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/19a11890-9d96-4050-8dc4-424c8d586189.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/d10b46c6-104e-4e6e-8a08-750492f0aad0.jpeg',
    styling: {
        tileColor: '#F5F1EA',
        matchColor: '#FFFFFF',
        circle: {
            bgColor: '#C5C442',
            iconColor: '#ffffff'
        }
    }
};

export const FJELLSPORT_THEME: GuideTheme = {
    id: 'fjellsport',
    coreColor: '#962B5A',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/88b95ff3-5cea-4eec-858e-0e5ad1ac6da2.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/85f5ad7c-a68d-4c2c-888d-4cba01acd5a1.jpeg',
    styling: {
        tileColor: '#FFF0F6',
        matchColor: '#FFFFFF',
        circle: {
            bgColor: '#2D292A',
            iconColor: '#ffffff'
        }
    }
};

export const PUSTKOVEC_THEME: GuideTheme = {
    id: 'pustkovec',
    coreColor: '#043A6A',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/e5cdb49a-cb93-49dd-95b6-c2bb82a0d34a.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/bab41629-dcda-41f3-a511-d63b7f09071f.jpeg',
    styling: {
        tileColor: '#EAF0F5',
        matchColor: '#FFFFFF',
        circle: {
            bgColor: '#089EE1',
            iconColor: '#ffffff'
        }
    }
};

export const PERFEKT_FAIR_THEME: GuideTheme = {
    id: 'perfektfair',
    coreColor: '#003DA5',
    headerImageUrl: 'https://dvtqxks0zalev.cloudfront.net/7647db9e-c541-4c7f-a474-1e75e2f198a4.png',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/21ea5c66-42a4-4d31-8b49-f56b436cc33c.png',
    styling: {
        tileColor: '#EAF0F5',
        matchColor: '#FFFFFF',
        circle: {
            bgColor: '#E4022B',
            iconColor: '#fff'
        }
    }
};

export const KONOPEX_THEME: GuideTheme = {
    id: 'konopex',
    coreColor: '#5B9929',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/72cc80b7-6ef0-44e8-9992-6799daa3808f.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/4d8f47de-7201-4b7b-bd85-2e0bebcafec8.jpeg',
    styling: {
        tileColor: '#EBF5EA',
        matchColor: '#FFFFFF',
        circle: {
            bgColor: '#2F4858',
            iconColor: '#ffffff'
        }
    }
};

export const SEAFOOD_THEME: GuideTheme = {
    id: 'seafood',
    coreColor: '#E0643E',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/e6011a15-d79c-460a-813d-819221d3f7a0.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/6f9abccb-1841-4700-b8a7-52a121845ae2.jpeg',
    styling: {
        tileColor: '#F5EFEA',
        matchColor: '#FFFFFF',
        circle: {
            bgColor: '#004766',
            iconColor: '#ffffff'
        }
    }
};

export const OLOMOUC_THEME: GuideTheme = {
    id: 'olomouc',
    coreColor: '#443176',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/edd9474e-5b1b-4586-a55d-6213e01198e7.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/4ae5ace3-d5de-498d-98a6-f17c16f00268.jpeg',
    styling: {
        tileColor: '#F0EAFF',
        matchColor: '#FFFFFF',
        circle: {
            bgColor: '#EE6936',
            iconColor: '#ffffff'
        }
    }
};

export const TSG24_THEME: GuideTheme = {
    id: 'tsg24',
    coreColor: '#131B3B',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/c388f810-1b7b-411b-8192-25bb759b90ae.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/1de3daa4-bdf1-41c9-914a-5d993144fc33.jpeg',
    styling: {
        tileColor: '#EBF4FA',
        matchColor: '#FFFFFF',
        circle: {
            bgColor: '#37B2CE',
            iconColor: '#ffffff'
        }
    }
};

export const NORTHMORAVIA_THEME: GuideTheme = {
    id: 'northmoravia',
    coreColor: '#6A542D',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/25bc8d29-5910-4bc8-adb1-48ab12c8ceb4.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/4e5a6e8b-d84c-4b7f-8c62-449e449663af.jpeg',
    styling: {
        tileColor: '#FAF4EB',
        matchColor: '#FFFFFF',
        circle: {
            bgColor: '#839C5A',
            iconColor: '#ffffff'
        }
    }
};

export const TRONDELAG_THEME: GuideTheme = {
    id: 'trondelag',
    coreColor: '#C5D6C7',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/a2d74bfa-d7af-4eef-989d-0c28d73b5c65.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/8c43690e-b246-466b-8385-a088507e43c4.jpeg',
    styling: {
        tileColor: '#FBFFFB',
        matchColor: '#050C4D',
        circle: {
            bgColor: '#050C4D',
            iconColor: '#ffffff'
        }
    }
};

export const KDAG_THEME: GuideTheme = {
    id: 'kdag',
    coreColor: '#003e5c',
    headerImageUrl: 'https://dvtqxks0zalev.cloudfront.net/eed089e1-821d-43c8-88ff-9b804fce3a4d.png',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/130bf322-6613-4a3d-baac-35cff420160b.png',
    styling: {
        tileColor: '#EAF0F5',
        matchColor: '#FFFFFF',
        circle: {
            bgColor: '#089EE1',
            iconColor: '#fff'
        }
    }
};

export const LIEGE_THEME: GuideTheme = {
    id: 'liege',
    coreColor: '#37B7E4',
    headerImageUrl: 'https://dvtqxks0zalev.cloudfront.net/e37c4f96-1385-421e-8ee2-dc87412c5cb4.png',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/c5728852-8d73-4dc9-8bd1-2351cddb4e23.png',
    styling: {
        tileColor: '#EAF0F5',
        matchColor: '#000',
        circle: {
            bgColor: '#DF4447',
            iconColor: '#fff'
        }
    }
};

export const VSCHT_THEME: GuideTheme = {
    id: 'vscht',
    coreColor: '#e4432d',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/3a77e8e6-d152-4d48-8e32-12e833eef7e8.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/e17045fd-064e-4b8c-b8ab-11f43144bd93.jpeg',
    styling: {
        tileColor: '#FCF7F4',
        matchColor: '#fff',
        circle: {
            bgColor: '#3A507A',
            iconColor: '#fff'
        }
    }
};

export const HURGHADA_THEME: GuideTheme = {
    id: 'hurghada',
    coreColor: '#443C17',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/93ea5ade-a8b0-42e5-b3d8-7dc4e1d4b8ee.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/fae5dad4-49be-47e3-a2c7-48d56da55b52.jpeg',
    styling: {
        tileColor: '#FFFCEB',
        matchColor: '#fff',
        circle: {
            bgColor: '#A5A82F',
            iconColor: '#fff'
        }
    }
};

export const OSU_THEME: GuideTheme = {
    id: 'osu',
    coreColor: '#443C17',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/d866bee0-9e13-44ae-b561-e1c1a97de349.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/b2c8d59c-1aa4-451c-9c61-0510b1dd378d.jpeg',
    styling: {
        tileColor: '#EBF4FA',
        matchColor: '#fff',
        circle: {
            bgColor: '#2E353F',
            iconColor: '#fff'
        }
    }
};

export const DOBRODRUZSTVI_THEME: GuideTheme = {
    id: 'dobrodruzstvi',
    coreColor: '#0CB8FF',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/61bd9603-9562-4559-b68a-1fe2c314ed9b.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/2c4f237e-7881-46bf-95fe-80a2d70e19a5.jpeg',
    styling: {
        tileColor: '#EBF4FA',
        matchColor: '#fff',
        circle: {
            bgColor: '#2E353F',
            iconColor: '#fff'
        }
    }
};

export const EXPOCIRK_THEME: GuideTheme = {
    id: 'expocirc',
    coreColor: '#F1B517',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/76249f65-a39b-4379-8844-d46326ddc25b.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/b447d149-1f4f-4afc-9c2b-0660c5225381.jpeg',
    styling: {
        tileColor: '#FAF7EB',
        matchColor: '#fff',
        circle: {
            bgColor: '#231F20',
            iconColor: '#fff'
        }
    }
};

export const BATER_THEME: GuideTheme = {
    id: 'bater',
    coreColor: '#37416B',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/b798f542-492d-419b-a798-b75d6d54c1bb.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/4db20010-bdfe-4adb-aab2-d304a78d6568.png',
    homepageTopImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/b3548106-802a-41ab-b380-ba501903d0cb.png',
    styling: {
        tileColor: '#EAF0F5',
        matchColor: '#fff',
        circle: {
            bgColor: '#C84545',
            iconColor: '#fff'
        },
        pageHeaderShadow: '1px 1px 2px black'
    }
};

export const CAMP_THEME: GuideTheme = {
    id: 'camp',
    coreColor: '#383E47',
    headerImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/57944e0a-fecc-4b35-a254-8ac22574768a.jpeg',
    brandImageUrl: 'https://dvtqxks0zalev.cloudfront.net/ed31c798-5d84-42ec-aaab-a49992db4bec.jpeg',
    homepageTopImageUrl:
        'https://dvtqxks0zalev.cloudfront.net/0eee1deb-cf42-4891-8d7f-08bf8e42171a.png',
    styling: {
        tileColor: '#F0F0F0',
        matchColor: '#F0F0F0',
        circle: {
            bgColor: '#F0CF69',
            iconColor: '#3B424A'
        },
        pageHeaderShadow: '1px 1px 2px black'
    }
};

export const GUIDE_THEMES = Object.fromEntries(
    [
        DEFAULT_THEME,
        DARK_THEME,
        LIGHT_THEME,
        KARIERA2024_THEME,
        BM_THEME,
        FREDRIKSTAD_THEME,
        MARENA_THEME,
        FJELLSPORT_THEME,
        NAMSSKOGAN_THEME,
        PUSTKOVEC_THEME,
        KONOPEX_THEME,
        SEAFOOD_THEME,
        OLOMOUC_THEME,
        UTRECHT_THEME,
        TSG24_THEME,
        NORTHMORAVIA_THEME,
        TRONDELAG_THEME,
        KDAG_THEME,
        LIEGE_THEME,
        VSCHT_THEME,
        HURGHADA_THEME,
        PERFEKT_FAIR_THEME,
        OSU_THEME,
        DOBRODRUZSTVI_THEME,
        EXPOCIRK_THEME,
        BATER_THEME,
        CAMP_THEME
    ].map((theme) => [theme.id, theme])
);
